'use client';

import { alpha, styled } from '@mui/material/styles';

import { StyledToolBar } from './StyledToolBar';

import type { ToolbarProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export const ToolbarShadowStyle = styled( 'div' )(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: 'calc(100% - 48px)',
  boxShadow: `-23px 16px 56px -8px ${
    alpha(
      theme.palette.mode === 'light'
        ? theme.palette.grey[500]
        : theme.palette.common.black,
      1
    )
  }`,
}));

export interface ToolBarProps extends ToolbarProps {
  transparent?: boolean;
  isScrolling?: boolean;
  height?: number;
}

/**
 * Customized Toolbar
 * Can be opaque or transparent
 * adds a custom Shadow when scrolling
 */
export const ToolBar = StyledToolBar;

// export const ToolBar: FC<PropsWithChildren<ToolBarProps>> = ( {
//   children,
//   transparent,
//   isScrolling,
//   height,
//   ...props
// } ) => (
//   <>
//     <StyledToolBar
//       disableGutters
//       transparent={transparent}
//       scrolling={isScrolling}
//       height={height ?? 100}
//       {...props}
//     >
//       {children}
//     </StyledToolBar>
//     {isScrolling && <ToolbarShadowStyle/>}
//   </>
// );
